import { render, staticRenderFns } from "./PostRequirement.vue?vue&type=template&id=25c1d32a"
import script from "./PostRequirement.vue?vue&type=script&lang=js"
export * from "./PostRequirement.vue?vue&type=script&lang=js"
import style0 from "./PostRequirement.vue?vue&type=style&index=0&id=25c1d32a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports